import PrivateMarketDeals from '../../Shared/PrivateMarketDeals';

const MembershipPrivateMarketDeals = (props) => {
  return <PrivateMarketDeals {...props} />;
};

export default MembershipPrivateMarketDeals;
